export default __webpack_public_path__ + "static/media/Major Rune Stone of the Proven Champion (V).daa6747a.jpg";